$(function() {
  var adStructure = $(`
    <div class="landing-advertise" api-boolean="user.webMain.advert">
      <div class="ad-bg"></div>
      <div class="ad-frame">
          <div class="btn-close-bg"></div>
          <div class="btn-close"></div>
          <div class="ad-image"><img src="" api-img="user.webMain.advert" /></div>
          <div class="ad-countdown"><span data-counter="5">-</span><span>&nbsp秒内关闭</span></div>
      </div>
    </div>`);

  if (location.pathname === "/home/") {
    $("body").append(adStructure);
  }

  let affId = readCookie("affid");
  let aff = getQueryVariable("aff");
  if (aff) {
    affId = aff;
  }
  createCookie("affid", affId);

  window.affCode = getQueryVariable("a");
  if (window.affCode) {
    createCookie("affCode", window.affCode);
  } else {
    window.affCode = readCookie("affCode");
  }

  api.checkLogin("", function(response) {
    if (response.data) {
      var data = response.data.data;
      $(".before-login").addClass("hide");
      $(".after-login").removeClass("hide");

      $("a.game-link")
        .removeClass("guestLoginBtn")
        .attr("href", "/member/index");

      $(".guestLoginBtn").remove();
      if (data.userType === 0 || data.tesing === 1) {
        $("#personalCenter").remove();
        $("#financialManagement").remove();
      }

      $("#loginUsername").text(data.userName);
    }
  });

  api.getMbConfigs(function(response) {
    if (response) {
      // window.publicConfigs.result.merge(response.data);
      const data = response.data.result;
      applyBannerSrc(data);
      applyConfig(data);

      // bind api and generate verification images functions after applying configs
      bindAPI();
      renderQrCode($(".qr-code"));
      // after config filter show whole page
      $("body").addClass("ready");

      window.applyConfig = function({ branding, config, action, qr }) {
        if (branding) {
          applyBannerSrc(data);
        }
        if (config) {
          applyConfig(data);
        }
        if (action) {
          bindAPI();
        }
        if (qr) {
          rendere($(".qr-code"));
        }
      };

      window.adInit();
    }
  });

  api.getNotice(function(response) {
    if (response) {
      const data = response.data.result;
      let notice = "";

      data.forEach(function(value, key) {
        notice += value.text + " ";
      });

      $(".marquee").text(notice);

      window.marqueeInit();
    }
  });

  api.getPromo(function(response) {
    if (response) {
      const data = response.data.result;
      window.promo = data;
    }
  });
});

function applyBannerSrc(data) {
  var types = {
    official: 0,
    ydl: 1,
    wdl: 2
  };
  var currentType = null;
  if (data["config.affKey"] != "1") {
    //Official
    currentType = types["official"];
    $("[aff-only]").remove();
    // All shows
  } else {
    if (data["config.aff"] == "2") {
      //YDL
      currentType = types["ydl"];
      $("#affLink").remove();
      $("[official-only]").remove();
      $("[aff-banner-src]").each(function() {
        replaceSrc($(this), "_ydl");
      });
      $("[aff-class]").each(function() {
        $(this).addClass("ydl");
      });
      // changeFavicon("favicon_ydl.ico");
    } else if (data["config.aff"] == "1") {
      //WDL
      currentType = types["wdl"];
      $('[api-img="logo.index"]').remove();
      $("#affLink").remove();
      $("[official-only]").remove();
      // document.title = "彩乐园";
      data["base.webname"] = "彩乐园";
      data["base.web.title"] = "彩乐园";
      $("[aff-banner-src],[aff-faq-src]").each(function() {
        replaceSrc($(this), "_wdl");
      });
      $("[aff-class]").each(function() {
        $(this).addClass("wdl");
      });
      // changeFavicon("img/favicon_wdl.ico");
      changeFaviconUrl("a");
    }
  }

  if (currentType !== types["official"]) $("[official-only]").remove();
  if (currentType !== types["wdl"]) $("[wdl-only]").remove();
  if (currentType !== types["ydl"]) $("[ydl-only]").remove();

  $("[api-show-with]").each(function(i, elem) {
    var typeFilter = $(elem).attr("api-show-with");
    switch (currentType) {
      case types["official"]:
        if (typeFilter.indexOf("official") == -1) $(elem).remove();
        break;
      case types["ydl"]:
        if (typeFilter.indexOf("ydl") == -1) $(elem).remove();
        break;
      case types["wdl"]:
        if (typeFilter.indexOf("wdl") == -1) $(elem).remove();
        break;
    }
  });

  function replaceSrc(selector, replacement) {
    var originalFullSrc = selector.attr("src").split(".");
    var originalSrc = originalFullSrc[0];
    var extension = originalFullSrc[1];
    selector.attr("src", originalSrc + replacement + "." + extension);
  }

  function changeFavicon(src) {
    var link = document.createElement("link"),
      oldLink = document.getElementById("dynamic-favicon");
    link.id = "dynamic-favicon";
    link.rel = "shortcut icon";
    link.href = src;
    if (oldLink) {
      document.head.removeChild(oldLink);
    }
    document.head.appendChild(link);
  }

  function changeFaviconUrl(replacement) {
    var link = document.createElement("link"),
      oldLink = document.getElementById("dynamic-favicon"),
      extension,
      originalName,
      urlLink,
      filename,
      newUrl;

    urlLink = oldLink.href;
    originalName = urlLink.lastIndexOf("/");
    extension = urlLink.lastIndexOf(".");
    filename = urlLink.substring(urlLink.lastIndexOf("/") + 1, extension);
    newUrl = urlLink.substring(0, originalName + 1) + filename + replacement + urlLink.substring(extension);

    link.id = "dynamic-favicon";
    link.rel = "shortcut icon";
    link.href = newUrl;

    if (oldLink) {
      document.head.removeChild(oldLink);
    }
    document.head.appendChild(link);
  }
}

function applyConfig(data) {
  $("[api-boolean]").each(function(i, elem) {
    const flagName = $(elem).attr("api-boolean");
    // console.log(flagName, data[flagName]);
    if (data[flagName] == "false" || !data[flagName]) $(elem).remove();
  });

  $("[api-string]").each(function(i, elem) {
    const flagName = $(elem).attr("api-string");
    $(elem).text(data[flagName]);
  });

  $("[api-link]").each(function(i, elem) {
    const flagName = $(elem).attr("api-link");
    $(elem).attr("href", data[flagName]);
  });

  $("[api-mail]").each(function(i, elem) {
    const flagName = $(elem).attr("api-mail");
    $(elem).attr("href", "mailto:" + data[flagName]);
  });

  $("[api-img]").each(function(i, elem) {
    const flagName = $(elem).attr("api-img");
    $(elem).attr("src", data[flagName]);
  });

  $("[api-qrcode]").each(function(i, elem) {
    const flagName = $(elem).attr("api-qrcode");
    $(elem).attr("data-qr-url", data[flagName]);
  });

  $("[api-qr-middleware]").each(function(i, elem) {
    const flagName = $(elem).attr("api-qr-middleware");
    $(elem).attr("data-qr-middleware", data[flagName]);
  });
}

// api binding
function bindAPI() {
  //! login
  {
    $("#loginBtn").click(function(event) {
      event.preventDefault();
      const button = this;
      $(button).prop("disabled", true);
      const enable = () => $(button).prop("disabled", false);

      const form = $("#loginForm");
      const username = form.find('[name="username"]').val();
      const password = form.find('[name="password"]').val();
      const code = form.find('[name="code"]').val();

      if (username == "") return alertBox({ message: "请输入帐号", type: "info", confirmFunc: enable });
      if (password == "") return alertBox({ message: "请输入密码", type: "info", confirmFunc: enable });
      if (code == "") return alertBox({ message: "请输入验证码", type: "info", confirmFunc: enable });

      api.login({ username, password, code }, function(response) {
        if (response.data.success) {
          location.href = "/member/agreement?" + response.data.message;
        } else {
          updateVCode();
          alertBox({ message: response.data.message, type: "error", confirmFunc: enable });
        }
      });
    });

    $("#guestLoginBtn, .guestLoginBtn").click(function() {
      var that = this;
      $(this).prop("disabled", true);
      alertBox({
        message: "游客盘口只供试玩，与正式会员盘口无关!",
        type: "info",
        confirmFunc: function() {
          api.login({ username: "!guest!", password: "!guest!" }, function(response) {
            if (response.data.success) {
              location.href = "/member/agreement?" + response.data.message;
            } else {
              updateVCode();
              alertBox({ message: response.data.message, type: "error" });
              $(this).prop("disabled", false);
            }
          });
        },
        cancelFunc: function() {
          $(that).prop("disabled", false);
          return false;
        }
      });
    });

    $("#depositBtn").click(function(e) {
      e.preventDefault();
      var that = this;
      api.checkLogin("", function(response) {
        if (response.data) {
          console.log(response);
          location.href = $(that).attr("href");
        } else {
          alertBox({
            message: "您还没有登录！",
            type: "warning",
            buttonText: {
              confirmText: "游客登录"
            },
            cancelFunc: function cancelFunc() {
              return false;
            },
            confirmFunc: function confirmFunc() {
              $("#guestLoginBtn").trigger("click");
            }
          });
        }
      });
    });
  }

  //! register
  {
    const form = $("#registerForm");

    if (window.affCode) {
      form.find('input[name="affKey"]').val(window.affCode);
    }

    form.find('[name="username"]').on("change", function(event) {
      event.preventDefault();
      const name = $(this).val();
      api.checkValidUser({ username: name }, function(data) {
        form.find('[data-hint-for="username"]').text("*" + (data || "该帐号可用"));
      });
    });

    form.find('button[type="submit"]').on("click", function(event) {
      event.preventDefault();
      const button = $(this);
      button.prop("disabled", true);
      function enable() {
        console.log("enable form");
        button.prop("disabled", false);
      }
      const password = form.find('input[name="password"]').val();
      const password1 = form.find('input[name="password1"]').val();
      const username = form.find('input[name="username"]').val();
      const affKey = form.find('input[name="affKey"]').val();
      const weChatId = form.find('input[name="wechat"]').val();
      const qqId = form.find('input[name="qq"]').val();
      const mobile = form.find('input[name="mobile"]').val();
      const code = form.find('input[name="code"]').val();
      const email = form.find('input[name="email"]').val();
      const name = form.find('input[name="fullName"]').val();
      const emailRegEx = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-za-z0-9]+$/;
      const mobileRegEx = new RegExp("^1(3|4|5|6|7|8|9)\\d{9}$");
      const weChatRegEx = new RegExp("^[a-zA-Z0-9_]+$");
      const qqRegEx = new RegExp("^[0-9]*$");

      if (username == "") return alertBox({ message: "请输入帐号", type: "info", confirmFunc: enable });
      if (username.length < 4 || username.length > 10)
        return alertBox({ message: "账号名称由4-10个数字字符组成", type: "info", confirmFunc: enable });

      if (affKey == "") return alertBox({ message: "请输入邀请码", type: "info", confirmFunc: enable });

      if (name == "") return alertBox({ message: "请输入真实姓名", type: "info", confirmFunc: enable });

      if (email != undefined && (email == "" || !emailRegEx.test(email)))
        return alertBox({ message: "请输入正确的电子邮件账号", type: "info", confirmFunc: enable });

      if (mobile != undefined && (mobile == "" || !mobileRegEx.test(mobile) || mobile.length > 11))
        return alertBox({ message: "请输入正确的11位数字手机号码", type: "info", confirmFunc: enable });

      if (weChatId !== undefined && weChatId.trim() == "") {
        return alertBox({ message: "请输入微信号", type: "info", confirmFunc: enable });
      } else if (weChatId !== undefined && (!weChatRegEx.test(weChatId) || weChatId.length < 4)) {
        return alertBox({ message: "请输入正确的微信号", type: "info", confirmFunc: enable });
      }

      if (qqId !== undefined && qqId.trim() == "") {
        return alertBox({ message: "请输入QQ号", type: "info", confirmFunc: enable });
      } else if (qqId !== undefined && (!qqRegEx.test(qqId) || qqId.length < 6)) {
        return alertBox({ message: "请输入正确的QQ号", type: "info", confirmFunc: enable });
      }

      if (password == "") return alertBox({ message: "请输入密码", type: "info", confirmFunc: enable });

      if (password.length < 6 || password.length > 20)
        return alertBox({ message: "密码不能小于6位字符或者多过20位字符", type: "info", confirmFunc: enable });

      if (password != password1)
        return alertBox({ message: "确认密码不相符,请重新输入", type: "warning", confirmFunc: enable });

      if (code == "") return alertBox({ message: "请输入验证码", type: "info", confirmFunc: enable });

      let affId = getQueryVariable("aff");
      if (affId == "" || affId == null) {
        affId = readCookie("affid");
      }

      const data = {
        parent: affId,
        username,
        password,
        affKey,
        weChatId,
        qqId,
        mobile,
        code,
        email,
        name
      };

      api.register(data, function(response) {
        if (response.data.success) {
          alertBox({
            message: "注册成功",
            type: "success",
            confirmFunc: function() {
              api.login(data, function(response) {
                if (response.data.success) {
                  location.href = "/member/agreement?" + response.data.message;
                }
              });
            }
          });
          if (form.parents(".modal").length !== 0) {
            form
              .parents(".modal")
              .find("[data-micromodal-close]")
              .off()
              .click();
          }
          form.find("input").val("");
        } else {
          switch (response.data.message) {
            case "验证码有误":
              alertBox({
                message: response.data.message,
                type: "error",
                confirmFunc: function() {
                  updateVCode();
                  form.find(`input[name="code"]`).val("");
                  enable();
                }
              });
              break;
            default:
              alertBox({
                message: response.data.message,
                type: "error",
                confirmFunc: function() {
                  updateVCode();
                  form.find(`input[name="code"]`).val("");
                  enable();
                }
              });
          }
        }
      });
    });
  }

  //! forgot password
  {
    const form = $("#forgotPasswordForm");
    form.find('button[type="submit"]').click(function(event) {
      event.preventDefault();
      const button = this;
      $(button).prop("disabled", true);
      function enable() {
        $(button).prop("disabled", false);
      }
      const data = {
        username: form.find('[name="username"]').val(),
        mobile: form.find('[name="mobile"]').val(),
        code: form.find('[name="code"]').val()
      };

      if (data.username == "") return alertBox({ message: "请输入帐号", type: "info", confirmFunc: enable });
      if (data.mobile == "") return alertBox({ message: "请输入绑定的手机号", type: "info", confirmFunc: enable });
      if (data.code == "") return alertBox({ message: "请输入验证码", type: "info", confirmFunc: enable });

      api.checkNameAndCode(data, function(response) {
        if (response.data.success) {
          location.href = "editpwd.html?name=" + data.username;
        } else {
          switch (response.data.message) {
            case "验证码有误":
              alertBox({
                type: "error",
                message: response.data.message,
                confirmFunc: function() {
                  updateVCode();
                  form.find('[name="code"]').val("");
                  enable();
                }
              });
              break;
            default:
              alertBox({
                type: "error",
                message: response.data.message,
                confirmFunc: function() {
                  updateVCode();
                  form.find('[name="code"]').val("");
                  enable();
                }
              });
          }
        }
      });
    });
  }
  //! set password
  {
    const form = $("#setPasswordForm");
    form.find('button[type="submit"]').click(function(event) {
      event.preventDefault();
      const button = this;
      $(button).prop("disabled", true);
      function enable() {
        $(button).prop("disabled", false);
      }
      const password = form.find('[name="password"]').val();
      const password1 = form.find('[name="password1"]').val();
      const code = form.find('[name="code"]').val();

      if (password == "") return alertBox({ message: "请输入新密码", type: "info", confirmFunc: enable });
      if (code == "") return alertBox({ message: "请输入验证码", type: "info", confirmFunc: enable });
      if (password != password1) return alertBox({ message: "确认密码不相符", type: "info", confirmFunc: enable });

      const data = {
        password,
        code,
        name: getQueryVariable("name")
      };

      api.setPassword(data, function(response) {
        if (response.data.success) {
          alertBox({
            type: "success",
            message: "密码修改成功",
            confirmFunc: function() {
              location.href = "/";
            }
          });
        } else {
          alertBox({
            type: "error",
            message: response.data.message,
            confirmFunc: enable
          });
        }
      });
    });
  }

  //Append PC app download function
  {
    $("body").append($(`<iframe class="download-frame" style="display: none;" src=""></iframe>`));

    if (isPCAppElectron()) {
      $(".pcapp-download").remove();
    }

    $(".pcapp-download").click(function(e) {
      e.preventDefault();
      var downloadLink = this.href;
      $(".download-frame").attr("src", downloadLink);
      setTimeout(function() {
        $(".download-frame").attr("src", "");
      }, 1000);
    });

    function isPCAppElectron() {
      return window.navigator.userAgent.toLowerCase().indexOf("electron") !== -1;
    }
  }

  $("img.verify-code").click(function(event) {
    event.stopPropagation();
    updateVCode();
  });
  updateVCode();
}

//! generate verify code
function updateVCode() {
  if ($("img.verify-code").length) {
    $("img.verify-code").css("pointer-events", "none");
    api.generateVCode(function(vcode) {
      $("img.verify-code").attr("src", vcode);
      $("img.verify-code").removeAttr("style");
    });
  }
}

function renderQrCode(selector) {
  selector.each(function(i, elem) {
    const target = $(elem);
    if (target.has("canvas").length !== 0) {
      target.find("canvas").remove();
    }
    target.append($("<canvas></canvas>"));
    const qrTarget = target.find("canvas");
    let url = target.data("qr-url");
    const size = target.data("size") || 150;
    const middleWareUrl = target.data("qr-middleware");
    const darkColor = target.data("qr-dark-color") || "#000000";
    const options = {
      margin: 1,
      width: size,
      height: size,
      color: {
        dark: darkColor
      }
    };
    let shortUrl = url ? url.split("://").slice(-1) : url;
    let currTarget = qrTarget;
    if (!isElement(qrTarget)) {
      currTarget = qrTarget[0];
    }
    // url = url;
    target.attr("title", url);
    if (target.parents(".appqr-wrapper").length !== 0) {
      target
        .parents(".appqr-wrapper")
        .find(".appdlurl")
        .text(shortUrl);
    }
    if (middleWareUrl) {
      // Call middleware server to request available domain
      var newUrl = "";
      if (middleWareUrl.indexOf("http://") === 0) {
        newUrl = middleWareUrl.replace("http://", "https://");
      } else {
        newUrl = middleWareUrl;
      }

      if (newUrl.slice(-1) == "/") {
        newUrl = newUrl.slice(0, -1);
      }

      $.ajax({
        url: newUrl + "/active",
        error: function(e) {
          console.error(e);
          QRCode.toCanvas(currTarget, url, options, function(error) {
            if (error) console.error(error);
          });
        }
      }).done(function(availableMiddleware) {
        url = "https://" + availableMiddleware + "?r=" + btoa(url) + "1";
        QRCode.toCanvas(currTarget, url, options, function(error) {
          if (error) console.error(error);
        });
      });
    } else {
      QRCode.toCanvas(currTarget, url, options, function(error) {
        if (error) console.error(error);
      });
    }
  });
}

function isElement(obj) {
  try {
    //Using W3 DOM2 (works for FF, Opera and Chrome)
    return obj instanceof HTMLElement;
  } catch (e) {
    //Browsers not supporting W3 DOM2 don't have HTMLElement and
    //an exception is thrown and we end up here. Testing some
    //properties that all elements have (works on IE7)
    return (
      typeof obj === "object" &&
      obj.nodeType === 1 &&
      typeof obj.style === "object" &&
      typeof obj.ownerDocument === "object"
    );
  }
}

function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const variables = query.split("&");
  for (var i = 0; i < variables.length; i++) {
    var pair = variables[i].split("=");
    if (decodeURIComponent(pair[0]) == variable) {
      return decodeURIComponent(pair[1]);
    }
  }
  console.log("Query variable %s not found", variable);
}

// Create cookie
function createCookie(name, value, days) {
  var expires;
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

// Read cookie
function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

// Erase cookie
function eraseCookie(name) {
  createCookie(name, "", -1);
}
